import React, { useState } from "react";
import { useNavigate, NavLink, useLocation } from "react-router-dom";
import { ChevronRight, X } from "lucide-react";
import { motion } from "framer-motion";
import { useDispatch } from "react-redux";
import { logoutUser } from "../requests/auth/Authentication";
import { logout } from "../redux/store";

const MobileNavbar = ({ isMenuOpen, setIsMenuOpen }) => {
  const closeMenu = () => setIsMenuOpen(false);
  const navigate = useNavigate();
  const [serveOpen, setServeOpen] = useState(false);
  const dispatch = useDispatch();

  const handleSignUp = () => {
    navigate("/signin");
  };

  const handleSignIn = () => {
    navigate("/select-login-option");
  };

  const location = useLocation();
  const isActive = (path) => location.pathname === path;

  const handleServeOpen = () => {
    setServeOpen(!serveOpen);
  };

  const handleLogout = async () => {
    try {
      await logoutUser();
      dispatch(logout());
      // The logout function in Redux store will handle navigation to landing page
    } catch (error) {
      console.error("Logout failed:", error);
      // If logout fails, still navigate to landing page
      window.location.href = "/";
    }
  };

  return (
    <>
      <motion.div
        className="fixed inset-0 z-40 p-4 px-10 py-24 w-screen h-screen backdrop-blur-lg bg-white/90"
        initial={{ x: "100%", opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        exit={{ x: "100%", opacity: 0 }}
        transition={{ duration: 0.5, ease: "easeInOut" }}
      >
        <div className="flex justify-end">
          <button
            className="p-2 text-2xl text-[#FF6C6C] bg-white rounded-md hover:bg-[#FF6C6C] hover:text-white lg:hidden hover:cursor-pointer transition duration-300 ease-in-out"
            onClick={closeMenu}
          >
            <X />
          </button>
        </div>

        {/* Mobile Menu */}
        <motion.div
          className="mt-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ delay: 0.3, duration: 0.5 }}
        >
          <ul className="space-y-4 text-[#FF6C6C]">
            <motion.li
              className="hover:text-[#FF6C6C] transition duration-200"
              whileHover={{ scale: 1.1, color: "#FF6C6C" }}
              transition={{ duration: 0.2 }}
            >
              <NavLink
                to="/home"
                className="block px-4 py-2"
                activeClassName="text-[#FF6C6C] font-bold"
                exact
              >
                Home
              </NavLink>
            </motion.li>
            <motion.li
              className="hover:text-[#FF6C6C] transition duration-200"
              whileHover={{ scale: 1.1, color: "#FF6C6C" }}
              transition={{ duration: 0.2 }}
            >
              <NavLink
                to="/faq"
                className="block px-4 py-2"
                activeClassName="text-[#FF6C6C] font-bold"
              >
                FAQ
              </NavLink>
            </motion.li>
           
            <motion.li
              className="hover:text-[#FF6C6C] transition duration-200"
              whileHover={{ scale: 1.1, color: "#FF6C6C" }}
              transition={{ duration: 0.2 }}
            >
              <NavLink
                to="/support"
                className="block px-4 py-2"
                activeClassName="text-[#FF6C6C] font-bold"
              >
                Support
              </NavLink>
            </motion.li>
          </ul>
        </motion.div>

        {/* Sign In and Sign Up Buttons */}
        <div className="mt-8 space-y-4">
          <motion.button
            onClick={handleSignUp}
            className="w-full py-2 bg-[#FF6C6C] text-white rounded-md hover:bg-[#ff4f4f] transition duration-300 ease-in-out"
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.3 }}
          >
            Get Started
          </motion.button>
          
        
        </div>
      </motion.div>
    </>
  );
};

export default MobileNavbar;
